module.exports = __webpack_public_path__ + "img/Orpea_logos.01ed6f61.png";